export default "__VITE_ASSET__CEh1hj4A__"